import { render, staticRenderFns } from "./ModalPollQuestion.vue?vue&type=template&id=1290cc66&scoped=true&"
import script from "./ModalPollQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalPollQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ModalPollQuestion.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalPollQuestion.vue?vue&type=style&index=1&id=1290cc66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290cc66",
  null
  
)

export default component.exports